import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import { connect } from 'react-redux';
import {
  showPopup,
  showSubscriptionDetails,
  goToPage,
  showPackageDetails,
  setTermAgreement,
  premiumPackageAction,
  setCurrentActionType,
  getSocList,
  reportAnalytics,
  setIsShowConfirmTermsMsg,
  setUserCurrentSubscription,
  setActionSuccessToFalse,
  setActionFailToFalse,
  setUserTvSuspended,
  clearAll,
  getTvSubscriptions,
} from '../PremiumPackagesHolder/PremiumPackagesHolderSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import EpiContext from '@episerver/spa-core/Spa';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper.scss';
import { isMobile } from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import PopUp from '../../../Shared/Popup/PopUp';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import CallBackLite from '../../../Shared/CallBackLite/CallBackLite';

SwiperCore.use([Autoplay, Pagination, Navigation]);

const premiumPackageDetails = (props) => {
  const [popupContent, setPopupContent] = useState(null);
  const [onPressXPopup, setOnPressXPopup] = useState(null);

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'visibility_4',
        eventLabel: props.packageInfo.packageName,
      });
      if (props.packageInfo.isShowWarning && !props.isUserCurrentSubscription) {
        setPopupContent(
          <div>
            <div>
              <p className='msg-title'>חשוב לנו שתדע!</p>
              <Image src={require('../images/icon_mobile.svg')} alt='מובייל' />
              <p className='msg-text'>{props.packageInfo.warningText}</p>
            </div>
            <BtnSubmit onclick={() => closeWarningPopupReport()} text='אוקי, הבנתי'></BtnSubmit>
          </div>
        );
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'visibility_11',
          eventLabel: 'element_13',
        });
        setOnPressXPopup(() => closePopupOnSuccess);
        props.showPopup({ show: true });
      }
    }
  }, []);

  useEffect(() => {
    if (props.actionFail) {
      setActionFailedMsgType();
      props.hideAppLoader();
      props.setActionFailToFalse();
    }
  }, [props.actionFail]);

  useEffect(() => {
    if (props.isShowSubscriptionDetails) {
      props.setTermAgreement(false);
      window.scrollTo(0, 0);
    }
  }, [props.isShowSubscriptionDetails]);

  useEffect(() => {
    if (props.actionSuccess) {
      if (props.currentActionType == 'ADD') {
        setPopupContent(
          <div>
            <p className='msg-title'>זהו, סיימנו להתקין את החבילה!</p>
            <Image src={require('../images/icons-ok-done.svg')} alt='הצלחה' />
            <p className='msg-text'>החבילה תהיה זמינה לצפייה תוך כמה דקות. בדיוק הזמן להתארגן על פופקורן ;)</p>
            <BtnSubmit onclick={() => closePopupOnSuccess()} text='אוקי'></BtnSubmit>
          </div>
        );
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'visibility_15',
          eventLabel: 'element_16',
        });
      }
      if (props.currentActionType == 'DELETE') {
        setPopupContent(
          <div>
            <p className='msg-title'>זהו, החבילה בוטלה</p>
            <Image src={require('../images/icons-ok-done.svg')} alt='הצלחה' />
            <p className='msg-text'>
              {props.packageInfo.subscriptionList[props.userSubscriberIndex].removedRemarkTextPopup &&
                props.packageInfo.subscriptionList[props.userSubscriberIndex].removedRemarkTextPopup.value}
            </p>
            <BtnSubmit onclick={() => closePopupOnSuccess()} text='אוקי'></BtnSubmit>
          </div>
        );
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'visibility_8',
          eventLabel: 'element_9',
        });
      }
      setOnPressXPopup(() => closePopupOnSuccess);
      props.hideAppLoader();
      props.showPopup({ show: true });
      props.setActionSuccessToFalse();
    }
  }, [props.actionSuccess]);

  let callToSupport = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_11',
      eventLabel: 'element_11',
    });
    return (window.location.href = 'tel:*'+ window.Config.technicalSupportPhone);
  };

  let closePopupOnSuccess = () => {
    props.clearAll();
    props.showPopup(false);
    backToPackages();
    props.getTvSubscriptions();
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
  };

  const closePopupOnFail = () => {
    props.showPopup(false);
  };

  const closeWarningPopupReport = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_14',
      eventLabel: 'element_14',
    });
    props.showPopup(false);
  };

  let setActionFailedMsgType = () => {
    var currentDate = new Date();
    if (currentDate.getHours() >= 9 && currentDate.getHours() < 18) {
      setPopupContent(
        <div>
          <p className='msg-title'>רק שנייה...</p>
          <Image src={require('../images/icons-error.svg')} alt='שגיא' />
          <p className='msg-text'>משהו קרה והחבילה לא {props.currentActionType == 'DELETE' ? 'בוטלה' : 'הותקנה'}</p>
          {isMobile ? (
            <BtnWhite
              onclick={() => callToSupport()}
              text={
                <>
                  <Image className='icon-phone' src={require('../images/icons-phone.svg')} alt='טלפון' /> דברו איתנו ב-{window.Config.technicalSupportPhone}
                </>
              }></BtnWhite>
          ) : (
            <div>
              <Image className='icon-phone' src={require('../images/icons-phone.svg')} alt='טלפון' />
              <span className='call-not-btn'> דברו איתנו ב-{window.Config.technicalSupportPhone}</span>
            </div>
          )}
        </div>
      );
      setOnPressXPopup(() => closePopupOnFail);
      props.showPopup({ show: true });
      if (props.currentActionType == 'DELETE') {
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'visibility_9',
          eventLabel: 'element_10',
        });
      }
      if (props.currentActionType == 'ADD') {
        props.reportAnalytics({
          eventCategory: 'premium_packages',
          eventAction: 'visibility_16',
          eventLabel: 'element_17',
        });
      }
    } else {
      setPopupContent(
        <CallBackLite
          IdNumber={props.userDetails.IDNumber}
          SubjectCode={props.packageInfo.callbackCode}
          title={'משהו השתבש...'}
          text={`משהו קרה והחבילה לא ${props.currentActionType == 'DELETE' ? 'בוטלה' : 'הותקנה'}`}
          close={closePopupOnSuccess}
        />
      );
      props.showPopup({ show: true });
      setOnPressXPopup(() => closePopupOnSuccess);
    }
  };

  let showDetailsHandler = (index) => {
    props.packageInfo.subscriptionList.length > 1 && props.goToPage('subscriptionDetails');
    props.showSubscriptionDetails({ show: true, idx: index });
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_15',
      eventLabel: props.packageInfo.packageName + ', ' + props.packageInfo.subscriptionList[index].subscriptionName.value,
    });
  };

  let backToSubscriptionList = () => {
    props.goToPage('packageDetails');
    props.showSubscriptionDetails({ show: false, idx: null });
    window.scrollTo(0, 0);
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_16',
      eventLabel: props.packageInfo.packageName,
    });
  };

  let backToPackages = () => {
    props.showSubscriptionDetails({ show: false, idx: null });
    props.showPackageDetails({ show: false, index: null });
    props.goToPage('packages');
    window.scrollTo(0, 0);
  };

  let backToPackagesFromUserSubs = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_7',
      eventLabel: props.packageInfo.packageName,
    });
    props.setUserCurrentSubscription(false);
    backToPackages();
    window.scrollTo(0, 0);
  };

  let displayMonthlyOrDaily = (daysDuration) => {
    if (daysDuration != 30) {
      return <span> מנוי חד פעמי עבור {daysDuration} ימים</span>;
    } else {
      return <span>מנוי חודשי</span>;
    }
  };

  let confirmRemoving = (data) => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_10',
      eventLabel: 'כן, אפשר',
    });
    if (data.serviceType == 'N') {
      props.setUserTvSuspended(true);
    } else {
      props.premiumPackageAction(data);
      props.showPopup(false);
      props.showAppLoader();
    }
  };

  let rejectRemoving = (data) => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_10',
      eventLabel: 'בעצם לא',
    });
    props.showPopup(false);
  };

  let premiumPackageActionHandler = (data) => {
    let productData = {
      subscriberId: props.selectedCellcomTvProd.subscriberId,
      productId: data.productId,
      action: data.action,
      subscriberNo: data.subscriberNo,
      socName: data.socName,
      socTitle: data.socTitle,
      serviceType: data.serviceType,
      daysDuration: data.daysDuration
    };
    if (data.action == 'DELETE') {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'click_6',
        eventLabel: props.packageInfo.packageName,
      });
      props.setCurrentActionType('DELETE');
      setPopupContent(
        <div>
          <p className='msg-title'>ביטול חבילה </p>
          <p className='msg-text'>לבטל את {data.name}? </p>
          <div className='btn-holder-popup'>
            <BtnSubmit onclick={() => confirmRemoving(productData)} text='כן, אפשר'></BtnSubmit>
            <BtnWhite onclick={() => rejectRemoving()} text='בעצם לא'></BtnWhite>
          </div>
        </div>
      );
      setOnPressXPopup(() => rejectRemoving);
      props.showPopup({ show: true });
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'visibility_6',
        eventLabel: 'element_7',
      });
    }
    if (data.action == 'ADD') {
      props.setCurrentActionType('ADD');
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'click_18',
        eventLabel: props.packageInfo.packageName,
      });
      if (props.isTermsAccepted) {
        props.showAppLoader(true);
        props.premiumPackageAction(productData);
      } else {
        props.setIsShowConfirmTermsMsg(true);
      }
    }
  };

  let showSubscriptionsList = () => {
    window.scrollTo(0, 0);
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_12',
      eventLabel: props.packageInfo.packageName,
    });
    return (
      <div className='subscriptions-container'>
        <p className='select-subscription-title'>איזה מסלול מתאים לכם?</p>
        <div>
          {props.packageInfo.subscriptionList.map(function (item, index) {
            return (
              <div key={index} className='subscription' onClick={() => showDetailsHandler(index)}>
                <div className='subscription-name'>{displayMonthlyOrDaily(item.daysDuration.value)}</div>
                <div className='subscription-left-side'>
                  <div className='subscription-price'>
                    <span>₪{item.price.value}</span>
                    <span>{item.daysDuration.value === 30 ? 'לחודש' : 'חד פעמי'} </span>
                  </div>
                  <Image src={require('../images/select_sub.svg')} alt='להזמנה' />
                </div>
              </div>
            );
          })}
        </div>
        <BtnWhite text={'חזור לכל החבילות'} onclick={() => backToPackages()} />
      </div>
    );
  };

  let termsAcceptHolder = (isAccepted) => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_17',
      eventLabel: props.packageInfo.packageName,
    });
    props.setTermAgreement(isAccepted);
  };

  let createSuggestedSubscriptionInfo = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_13',
      eventLabel: props.packageInfo.packageName,
    });
    return (
      <div className='subscription-details-container'>
        {props.packageInfo.subscriptionList.length > 1 && (
          <div className='subscription-details-close'>
            <span>בחירה מצוינת!</span>
            <span onClick={() => backToSubscriptionList()}>לבחירת מסלול אחר</span>
          </div>
        )}
        <div className='subscription-details'>
          <div className='selected-subscription-title'>
            <span className='selected-subscription-name'>
              {displayMonthlyOrDaily(props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].daysDuration.value)}
            </span>
            <div className='selected-subscription-price'>
              <span>₪{props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].price.value}</span>
              <span>
                {props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].daysDuration.value === 30 ? 'לחודש' : 'חד פעמי'}{' '}
              </span>
            </div>
          </div>
          {props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].description.value != '' ? (
            <p className='description'>{props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].description.value}</p>
          ) : null}
        </div>
        <div className='subscription-terms'>
          <div className='terms-checkbox'>
            <CheckBox
              id='subscriptionApproveTerms'
              onCheck={(e) => termsAcceptHolder(true)}
              onUncheck={() => {
                termsAcceptHolder(false);
              }}></CheckBox>
            <p className='subscription-terms-text'>
              <span>אישרתי את</span>
              <a target='_blank' onClick={() => buildUrlAndOpenWindow(props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].subscriptionTermsLink.value)}>תנאי החבילה</a>
            </p>
          </div>
          {props.isShowConfirmTermsMsg ? <div className='terms-warning'>חובה לאשר את תנאי החבילה </div> : null}
        </div>
        <BtnSubmit
          text={'לרכישה'}
          onclick={() => {
            props.selectedCellcomTvProd.isCollectionProblem
              ? props.setUserTvSuspended(true)
              : premiumPackageActionHandler({
                productId: props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].productID.value,
                socName: props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].socsList.expandedValue[0].socName.value,
                socTitle: props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].socsList.expandedValue[0].socTitle.value,
                daysDuration: props.packageInfo.subscriptionList[props.selectedSubscriptionIdx].daysDuration.value,
                subscriberNo: props.selectedCellcomTvProd.subscriberNo,
                action: 'ADD',
              });
          }}
        />
      </div>
    );
  };

  let usersSubscriptionInfo = () => {
    window.scrollTo(0, 0);
    if (props.existingPackagesList[props.userPackageIndex].expired) {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'visibility_5',
        eventLabel: props.packageInfo.packageName,
      });
    }
    return (
      <>
        {props.existingPackagesList[props.userPackageIndex].expired ? (
          <section className='user-subscription-info'>
            <div className='info-container'>
              <p className='user-subscription-name'>{props.existingPackagesList[props.userPackageIndex].socTitle}</p>
              <p className='user-subscription-expired'>
                מסתיים ב-{' '}
                {(
                  props.existingPackagesList[props.userPackageIndex].expired.slice(0, 4) +
                  '.' +
                  props.existingPackagesList[props.userPackageIndex].expired.slice(4, 6) +
                  '.' +
                  props.existingPackagesList[props.userPackageIndex].expired.slice(6, 8)
                )
                  .split('.')
                  .reverse()
                  .join('.')}
              </p>
            </div>
          </section>
        ) : (
          <section>
            <div
              className='btn-delete'
              onClick={() =>
                premiumPackageActionHandler({
                  productId: props.existingPackagesList[props.userPackageIndex].productID,
                  serviceType: props.existingPackagesList[props.userPackageIndex].serviceType,
                  socName: props.existingPackagesList[props.userPackageIndex].socName,
                  socTitle: props.existingPackagesList[props.userPackageIndex].socTitle,
                  subscriberNo: props.selectedCellcomTvProd.subscriberNo,
                  action: 'DELETE',
                  name: props.existingPackagesList[props.userPackageIndex].name,
                })
              }>
              ביטול חבילה
            </div>
          </section>
        )}

        <BtnWhite text={'חזרה'} onclick={() => backToPackagesFromUserSubs()} />
      </>
    );
  };

  return (
    <section className='package-details-container'>
      {isMobile ? null : (
        <div className='header'>
          <p>{window.Config.brand_Name_HE} TV</p>
          <p>{props.packageInfo.packageName}</p>
        </div>
      )}
      <div className='package-header'>
        {isMobile ? (
          <div className='package-header-title'>
            <span className='package-name'>{props.packageInfo.packageName}</span>
          </div>
        ) : null}
        <Image className='package-header-img'
          src={EpiContext.getEpiserverUrl(isMobile ? props.packageInfo.mobileImage : props.packageInfo.desktopImage)}
          alt='ערוצים' />
      </div>
      <div className='details-container'>
        {props.packageInfo.channelsList ? (
          <>
            <p className='include_text'>הערוצים הכלולים בחבילה</p>
            {props.packageInfo.channelsList.length > (isMobile ? 2 : 7) ? (
              <div className='carousel-container'>
                <Swiper
                  autoplay={{ delay: 0, disableOnInteraction: false }}
                  spaceBetween={10}
                  slidesPerView='auto'
                  speed={4000}
                  centeredSlides
                  loop
                  loopedSlides={props.packageInfo.channelsList.length || 1}>
                  {props.packageInfo.channelsList.map(function (item, index) {
                    return (
                      <SwiperSlide key={index}>
                        <div className='swiper-slide'>
                          <div className='channel-container running'>
                            <div className='channel-img-holder'>
                              <Image className='channel-img'
                                src={EpiContext.getEpiserverUrl(item.image.value ? item.image.value.url : null)}
                                alt='תמונת ערוץ' />
                            </div>
                            <p className='channel-name' dir='auto'>
                              {item.channelName.value}
                            </p>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            ) : (
              <div className='carousel-container'>
                <div className='channels-static'>
                  {props.packageInfo.channelsList.map(function (item, index) {
                    return (
                      <div key={index}>
                        <div className='swiper-slide channel'>
                          <div className='channel-container'>
                            <div className='channel-img-holder'>
                              <Image className='channel-img'
                                src={EpiContext.getEpiserverUrl(item.image.value ? item.image.value.url : null)}
                                alt='תמונת ערוץ' />
                            </div>
                            <p className='channel-name' dir='auto'>
                              {item.channelName.value}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </>
        ) : null}
        <p className='package-description'>{props.packageInfo.description}</p>
        {props.packageInfo.lawText ? (
          <div className='attention'>
            <Image src={require('../images/icons_attention.svg')} alt='חשוב שתדעו' />
            <div className='mobile-warning'>
              <span>חשוב לדעת</span>
              <span>{props.packageInfo.lawText}</span>
            </div>
          </div>
        ) : null}
        {props.isShowSubscriptionDetails
          ? null
          : props.isUserCurrentSubscription
            ? usersSubscriptionInfo()
            : props.packageInfo.subscriptionList.length == 1
              ? showDetailsHandler(0)
              : showSubscriptionsList()}
        {props.isShowSubscriptionDetails && !props.isUserCurrentSubscription ? createSuggestedSubscriptionInfo() : null}
      </div>
      <section className='message-popup'>
        <PopUp showPopUp={props.isShowPopup} onClose={onPressXPopup}>
          {popupContent}
        </PopUp>
      </section>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    isShowPopup: state.premiumPackages.isShowPopup,
    isShowSubscriptionDetails: state.premiumPackages.isShowSubscriptionDetails,
    selectedSubscriptionIdx: state.premiumPackages.selectedSubscriptionIdx,
    existingPackagesList: state.premiumPackages.existingPackagesList,
    isUserCurrentSubscription: state.premiumPackages.isUserCurrentSubscription,
    userSubscriberIndex: state.premiumPackages.userSubscriberIndex,
    cellcomTvList: state.premiumPackages.cellcomTvList,
    selectedCellcomTvProd: state.premiumPackages.selectedCellcomTvProd,
    actionFail: state.premiumPackages.actionFail,
    actionSuccess: state.premiumPackages.actionSuccess,
    currentActionType: state.premiumPackages.currentActionType,
    userDetails: state.authentication.loginData.userDetails,
    isTermsAccepted: state.premiumPackages.isTermsAccepted,
    isShowConfirmTermsMsg: state.premiumPackages.isShowConfirmTermsMsg,
    subscriptionPriceForDisplay: state.premiumPackages.subscriptionPriceForDisplay,
    selectedPackageIndex: state.premiumPackages.selectedPackageIndex,
    userPackageIndex: state.premiumPackages.userPackageIndex,
  };
};

const mapDispatchToProps = {
  showPopup,
  goToPage,
  showSubscriptionDetails,
  showPackageDetails,
  setTermAgreement,
  premiumPackageAction,
  showAppLoader,
  hideAppLoader,
  setCurrentActionType,
  getSocList,
  reportAnalytics,
  setIsShowConfirmTermsMsg,
  setUserCurrentSubscription,
  setActionSuccessToFalse,
  setActionFailToFalse,
  setUserTvSuspended,
  clearAll,
  getTvSubscriptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(premiumPackageDetails);
